/* Presentation only: decorate the existing plan, never modify optimizer/cart/PDF data. */
(() => {
  const namespace = 'http://www.w3.org/2000/svg';
  const svgNode = (name, attributes, text) => {
    const node = document.createElementNS(namespace, name);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, String(value)));
    if (text !== undefined) node.textContent = text;
    return node;
  };

  function legend(root) {
    const key = document.createElement('div');
    key.className = 'fibrolux-cut-plan-legend';
    ['piece', 'rest', 'line'].forEach(type => {
      const item = document.createElement('span');
      const swatch = document.createElement('i');
      swatch.className = `fibrolux-cut-plan-swatch--${type}`;
      swatch.setAttribute('aria-hidden', 'true');
      item.append(swatch, document.createTextNode(root.dataset[`plan${type[0].toUpperCase()}${type.slice(1)}`] || type));
      key.append(item);
    });
    return key;
  }

  function dimensionsList(values) {
    const list = document.createElement('ul');
    list.className = 'fibrolux-cut-plan-pieces';
    const counts = new Map();
    values.forEach(value => counts.set(value, (counts.get(value) || 0) + 1));
    counts.forEach((count, value) => {
      const item = document.createElement('li');
      item.textContent = `${count} × ${value}`;
      list.append(item);
    });
    return list;
  }

  function decorateSheet(svg) {
    if (svg.dataset.planStyled) return;
    const frame = svg.querySelector(':scope > rect[fill="none"]');
    if (!frame) return;
    const x = Number(frame.getAttribute('x'));
    const y = Number(frame.getAttribute('y'));
    const width = Number(frame.getAttribute('width'));
    const height = Number(frame.getAttribute('height'));
    if (![x, y, width, height].every(Number.isFinite) || width <= 0 || height <= 0) return;
    svg.dataset.planStyled = 'true';
    svg.classList.add('fibrolux-cut-plan-svg');
    const font = Math.max(width, height) / 27;
    // Reserve space outside the unchanged raw-sheet and cut coordinates.
    svg.setAttribute('viewBox', `${x - font * 3} ${y - font * .6} ${width + font * 3.6} ${height + font * 4}`);
    frame.classList.add('fibrolux-cut-plan-frame');
    frame.setAttribute('rx', '0');
    svg.querySelectorAll('pattern[id*="-rest-pattern-"] line').forEach(e => e.classList.add('fibrolux-cut-plan-hatch'));
    svg.querySelectorAll('pattern[id*="-rest-pattern-"] rect').forEach(e => e.setAttribute('fill', '#fff'));
    svg.querySelectorAll('pattern[id*="-mesh-pattern-"] rect').forEach(e => e.setAttribute('fill', '#565656'));
    svg.querySelectorAll(':scope > g[fill]').forEach(e => e.setAttribute('fill', '#565656'));
    svg.querySelectorAll(':scope > rect[fill*="-mesh-pattern-"]').forEach(e => e.setAttribute('opacity', '.09'));
    svg.querySelectorAll(':scope > line').forEach(e => e.classList.add('fibrolux-cut-plan-line'));

    const dimension = svgNode('g', {class: 'fibrolux-cut-plan-dimensions'});
    const bottom = y + height + font * 1.2;
    const left = x - font * 1.2;
    const tick = font * .25;
    [[x,bottom,x+width,bottom], [x,bottom-tick,x,bottom+tick], [x+width,bottom-tick,x+width,bottom+tick],
      [left,y,left,y+height], [left-tick,y,left+tick,y], [left-tick,y+height,left+tick,y+height]]
      .forEach(([x1,y1,x2,y2]) => dimension.append(svgNode('line', {x1,y1,x2,y2})));
    dimension.append(svgNode('text', {x:x+width/2,y:bottom+font*1.35,'text-anchor':'middle','font-size':font}, `${width} mm`));
    dimension.append(svgNode('text', {x:0,y:0,transform:`translate(${left-font*.55} ${y+height/2}) rotate(-90)`,'text-anchor':'middle','font-size':font}, `${height} mm`));

    const values = [];
    svg.querySelectorAll(':scope > rect[fill*="-cut-gradient-"]').forEach(rect => {
      const w = Number(rect.getAttribute('width'));
      const h = Number(rect.getAttribute('height'));
      const value = `${w} × ${h} mm`;
      values.push(value);
      rect.classList.add('fibrolux-cut-plan-piece');
      rect.setAttribute('rx', '0');
      // Labels only where they fit; the list below covers small cuts and touch devices.
      if (w > value.length * font * .56 && h > font * 1.8) {
        dimension.append(svgNode('text', {x:Number(rect.getAttribute('x'))+w/2,y:Number(rect.getAttribute('y'))+h/2,'dominant-baseline':'middle','text-anchor':'middle','font-size':font}, value));
      }
    });
    svg.append(dimension);
    svg.after(dimensionsList(values));
  }

  function decorate(root) {
    root.querySelectorAll('[data-preview]').forEach(preview => {
      preview.querySelectorAll('svg').forEach(decorateSheet);
      if (preview.querySelector('svg') && !preview.querySelector('.fibrolux-cut-plan-legend')) preview.append(legend(root));
    });
    root.querySelectorAll('[data-bar]').forEach(preview => {
      preview.querySelectorAll('.cut-configurator__bar').forEach(bar => {
        if (bar.dataset.planStyled) return;
        bar.dataset.planStyled = 'true';
        const values = [...bar.querySelectorAll('.cut-configurator__segment--piece')].map(e => e.title).filter(Boolean);
        bar.append(dimensionsList(values));
      });
      if (preview.querySelector('.cut-configurator__bar') && !preview.querySelector('.fibrolux-cut-plan-legend')) preview.append(legend(root));
    });
  }

  function init(container) {
    const roots = [...container.querySelectorAll('.fibrolux-zuschnitt--finder-ui')];
    if (container.matches?.('.fibrolux-zuschnitt--finder-ui')) roots.push(container);
    roots.forEach(root => {
      if (root.dataset.planDesignReady) return;
      root.dataset.planDesignReady = 'true';
      decorate(root);
      const observer = new MutationObserver(() => decorate(root));
      root.querySelectorAll('[data-preview], [data-bar]').forEach(preview => observer.observe(preview, {childList:true,subtree:true}));
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, {once:true});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
